import { render, staticRenderFns } from "./salaryList.vue?vue&type=template&id=4d76140e&scoped=true&"
import script from "./salaryList.vue?vue&type=script&lang=js&"
export * from "./salaryList.vue?vue&type=script&lang=js&"
import style0 from "./salaryList.vue?vue&type=style&index=0&id=4d76140e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d76140e",
  null
  
)

export default component.exports